import { render, staticRenderFns } from "./ganyu.vue?vue&type=template&id=4353f693&scoped=true&"
import script from "./ganyu.vue?vue&type=script&lang=ts&"
export * from "./ganyu.vue?vue&type=script&lang=ts&"
import style0 from "./ganyu.vue?vue&type=style&index=0&id=4353f693&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4353f693",
  null
  
)

export default component.exports